import {
  CcfBox,
  CcfDivider,
  CcfTypography,
  DividerOrientation,
  DividerVariant,
} from '@nice-ccf/ui-controls';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import styles from './ccf-notes-card.module.scss';
import { Button, Card, CardContent, IconButton } from '@mui/material';
import { useState } from 'react';

/* eslint-disable-next-line */
export interface CcfNotesCardProps {
  note: any;
  handleNotesView: any;
  editNote: any;
  updatedNote: any;
  setUpdatedNote: any;
}

/**@example */
export function CcfNotesCard(props: CcfNotesCardProps) {
  const { note, handleNotesView, editNote, updatedNote, setUpdatedNote } =
    props;

  const [editMode, setEditMode] = useState(false);

  /**@example */
  const updatedEditedNote = (value: any) => {
    setUpdatedNote(value);
  };

  return (
    <Card
      variant="outlined"
      style={{ marginBottom: '5px', cursor: 'pointer' }}
      // onClick={onClickNotesCard}
      className={`${
        note.expandedMaxContent ? styles.activeNote : 'inactiveNote'
      }`}
    >
      <CardContent className={styles.notesCardContent}>
        <CcfBox className={styles.notesDetailsBlock}>
          <CcfBox className={styles.minParentContainer}>
            <CcfBox className={styles.notesDetails}>
              <CcfTypography className={styles.noteTitle}>
                {note.noteTitle}
              </CcfTypography>
              <CcfTypography className={styles.skillName}>
                {note.time} | {note.subTitle}
              </CcfTypography>
              <CcfTypography className={styles.agentName}>
                #{note.contactTrackingId} | {note.agentName}
              </CcfTypography>
            </CcfBox>
            {/* <CcfBox className={styles.expandBlock}> */}
            <IconButton
              onClick={() => {
                handleNotesView(note);
              }}
            >
              <ExpandMoreIcon
                className={styles.arrowBlock}
                style={{
                  transform: note.expandedMaxContent
                    ? 'rotate(180deg)'
                    : 'none',
                }}
              />
            </IconButton>
            {/* </CcfBox> */}
          </CcfBox>
          <CcfBox>
            {' '}
            {note.expandedMaxContent && (
              <div>
                <CcfDivider
                  orientation={DividerOrientation.HORIZONTAL}
                  variant={DividerVariant.FULLWIDTH}
                  sx={{
                    width: '100%',
                    borderColor: '#D2D8DB',
                    margin: '10px 0px',
                  }}
                />
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  {!editMode ? (
                    <CcfBox>
                      <CcfTypography
                        translationKey={note.noteContent}
                        className={styles.maxContent}
                      ></CcfTypography>
                    </CcfBox>
                  ) : (
                    <CcfBox className={styles.editBox}>
                      <textarea
                        id="editNote"
                        className={styles.note_textarea}
                        value={updatedNote}
                        onChange={(event: any) => {
                          event.preventDefault();
                          updatedEditedNote(event?.target.value);
                        }}
                      ></textarea>
                    </CcfBox>
                  )}
                  {!editMode ? (
                    <CcfBox
                      style={{ display: 'flex', justifyContent: 'flex-end' }}
                    >
                      <Button
                        style={{ padding: 0, minWidth: '55px' }}
                        onClick={() => {
                          setEditMode(true);
                          // editNote(note);
                        }}
                      >
                        <CcfTypography
                          translationKey="edit"
                          className={styles.editbutton}
                        ></CcfTypography>
                      </Button>
                    </CcfBox>
                  ) : (
                    <CcfBox
                      style={{ display: 'flex', justifyContent: 'flex-end' }}
                    >
                      <Button
                        style={{ padding: 0 }}
                        onClick={() => {
                          setEditMode(false);
                          editNote(note, updatedNote);
                        }}
                      >
                        <CcfTypography
                          translationKey="save"
                          className={styles.editbutton}
                        ></CcfTypography>
                      </Button>
                    </CcfBox>
                  )}
                </div>
              </div>
            )}
          </CcfBox>
        </CcfBox>
      </CardContent>
    </Card>
  );
}

export default CcfNotesCard;
